import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./usePlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./usePlanEnrollments";
import { IPlanEnrollment } from "../../services/api/planEnrollment/types";
import { withdrawCancellationPlanEnrollment } from "../../services/api/planEnrollment/withdrawCancellationPlanEnrollment";
import { QUERY_INSURANCE_COVERAGE } from "../insuranceCoverage/queries/useInsuranceCoverage";
import { QUERY_INSURANCE_COVERAGES } from "../insuranceCoverage/queries/useInsuranceCoverages";
import { QUERY_LIST_RESOURCE_EVENTS } from "../resourceEvents/queries/useQueryListEvents";

export const useWithdrawCancellationPlanEnrollment = (
  config?: WSMutationsConfig<IPlanEnrollment, WSServiceError>
) =>
  useWSMutation(
    (planEnrollmentId: string) =>
      withdrawCancellationPlanEnrollment(planEnrollmentId),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        QUERY_INSURANCE_COVERAGE,
        QUERY_INSURANCE_COVERAGES,
        QUERY_LIST_RESOURCE_EVENTS
      ],
      ...config
    }
  );
